export const LINE_SEGMENT_THRESHOLD = 0.05;
export const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
export const SERIALIZATION_PRECISION = 2;
export const DISTANCE_PRECISION = 3;
export const DISTANCE_EPSILON = Math.pow(10, -DISTANCE_PRECISION);
export const ANGLE_PRECISION = 6;
export const ANGLE_EPSILON = Math.pow(10, -ANGLE_PRECISION);
export const GEOM_TOLERANCE = 1.0e-8;
